// @flow
import { useContext } from 'react';
import { DEAL_TYPE_BACKEND_NAME, DEAL_TYPE_RENEWAL } from '@src/constants';

import { EstimateContext } from '../contexts/EstimateContext';

export const getIsEstimateRenewal = (estimate) =>
  estimate?.inputs?.[DEAL_TYPE_BACKEND_NAME] === DEAL_TYPE_RENEWAL;

export const useIsEstimateRenewal = () => {
  const estimate = useContext(EstimateContext);
  return getIsEstimateRenewal(estimate);
};
